"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberV2ByLocale = exports.getNumberV2ByCountry = exports.getNumberV2 = exports.getCurrencyByPatternByCountry = exports.getCurrencyByPattern = exports.initBase = void 0;
var __1 = require("..");
var interface_1 = require("../common/interface");
var helper_1 = require("../utils/helper");
var constants_1 = require("../utils/constants");
var initBase = function () {
    return new Promise(function (resolve) {
        resolve();
    });
};
exports.initBase = initBase;
var getCurrencyByPattern = function (num) {
    var _a, _b;
    (0, helper_1.validateFunction)(__1.Config.locale, 'locale');
    (0, helper_1.validateFunction)(__1.Config.country, 'country');
    var currency;
    var result;
    try {
        currency =
            ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.currency[constants_1.CURRENCY_MAP[__1.Config.country]][__1.Config.locale]) ||
                ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.currency[constants_1.CURRENCY_MAP[__1.Config.country]].default);
    }
    catch (e) {
        /* empty */
    }
    if (currency) {
        result = currency.pattern.replace(/[#,.0]+/, /\.00/.test(currency.pattern)
            ? num.toLocaleString('en-US') + (num ? '' : '.00')
            : Math.round(num).toLocaleString('en-US'));
        if (num < 0)
            result = "-".concat(result.replace('-', ''));
    }
    else {
        try {
            var ICU_locale = __1.Config.locale === 'ar-EG' ? 'ar-EG-u-nu-latn' : __1.Config.locale;
            result = Intl.NumberFormat(ICU_locale, {
                style: 'currency',
                currency: constants_1.CURRENCY_MAP[__1.Config.country]
            }).format(num);
        }
        catch (e) {
            /* empty */
        }
    }
    return result;
};
exports.getCurrencyByPattern = getCurrencyByPattern;
var getCurrencyByPatternByCountry = function (num, country, locale) {
    var _a, _b;
    if (!country) {
        if (!__1.Config.country) {
            throw Error('Elvish Error: please call getCurrencyByPatternByCountry const with country parameter first');
        }
        else {
            country = __1.Config.country;
        }
    }
    if (!locale) {
        if (!__1.Config.locale) {
            throw Error('Elvish Error: please call getCurrencyByPatternByCountry const with locale parameter first');
        }
        else {
            locale = __1.Config.locale;
        }
    }
    var currency;
    var result;
    try {
        currency =
            ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.currency[constants_1.CURRENCY_MAP[country]][locale]) ||
                ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.currency[constants_1.CURRENCY_MAP[country]].default);
    }
    catch (e) {
        /* empty */
    }
    if (currency) {
        result = currency.pattern.replace(/[#,.0]+/, /\.00/.test(currency.pattern)
            ? num.toLocaleString('en-US') + (num ? '' : '.00')
            : Math.round(num).toLocaleString('en-US'));
        if (num < 0)
            result = "-".concat(result.replace('-', ''));
    }
    else {
        try {
            var ICU_locale = locale === 'ar-EG' ? 'ar-EG-u-nu-latn' : locale;
            result = Intl.NumberFormat(ICU_locale, {
                style: 'currency',
                currency: constants_1.CURRENCY_MAP[country]
            }).format(num);
        }
        catch (e) {
            /* empty */
        }
    }
    return result;
};
exports.getCurrencyByPatternByCountry = getCurrencyByPatternByCountry;
// 配置里的NumberV2
var getNumberV2 = function () {
    var _a, _b;
    (0, helper_1.validateFunction)(__1.Config.locale, 'locale');
    return ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.numberV2[__1.Config.locale]) || ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.numberV2.default);
};
exports.getNumberV2 = getNumberV2;
// 配置里的NumberV2(按照传入的国家匹配)
var getNumberV2ByCountry = function (country) {
    var _a, _b;
    var locale = (0, interface_1.getLocaleByCountry)(country);
    if (!locale) {
        locale = __1.Config.locale;
    }
    (0, helper_1.validateFunction)(__1.Config.locale, 'locale', 'getNumberV2ByCountry const');
    return ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.numberV2[locale]) || ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.numberV2.default);
};
exports.getNumberV2ByCountry = getNumberV2ByCountry;
// 配置里的NumberV2(按照传入的locale匹配)
var getNumberV2ByLocale = function (locale) {
    var _a, _b;
    if (!locale) {
        locale = __1.Config.locale;
    }
    (0, helper_1.validateFunction)(__1.Config.locale, 'locale', 'getNumberV2ByCountry const');
    return ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.numberV2[locale]) || ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.numberV2.default);
};
exports.getNumberV2ByLocale = getNumberV2ByLocale;
